import { Component, Fragment } from 'preact';
import { route } from "preact-router";
import PFeed from "../../../services/prematch-feed";
import MenuTimeFilter from "../mobile-components/menu-time-filter";
import { TodayWidget } from '../mobile-components/today-widget.jsx';
import FullSite from './full-site';
import { SearchComponent } from "./prematch.jsx";


import * as P from "../mobile-templates/sports";


export default function Today(props) {
	return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit"><TodayPage {...props} /></FullSite>

}
export class TodayPage  extends Component{
	state = {
		sport: null
	};

	componentWillMount() {
		this.useBestSport()
	}
	useBestSport() {
		if (this.state.sport === null ||(PFeed.menu && !PFeed.menu[this.state.sport])) {
			let firstAttempt = '/sport/'+this.props.sportId;
			
			const sportId = !!PFeed.menu[firstAttempt]
				? firstAttempt
				: Object.values(PFeed.menu).sort((a, b) =>a.order - b.order)[0].id;
			this.setState({sport: sportId})
		} else {
			this.setState({})
		}
	}

    setSport(sport) {
		this.setState({sport: sport.id})
		this.setSportRoute(sport.id.split('/').slice(-1)[0])
	}
	setSportRoute(sportId) {
		route('/today/'+sportId)
	}
    getCurrentSport() {
		return PFeed.menu && PFeed.menu[this.state.sport];
	}
	render() {
		const menu = PFeed.menu;
		return <Fragment>
					<P.SportsHolder>
						{menu && Object.values(menu).sort((a, b) => a.order - b.order).slice(0,7).map(sport => {
							return <P.SportButton
							sport={sport}
							active={sport.id == this.state.sport}
							onClick={e => this.setSport(sport)}
							/>
						})}
					</P.SportsHolder>
					<P.HeaderContainer>
						<MenuTimeFilter />
						<SearchComponent />
					</P.HeaderContainer>
					{this.getCurrentSport() && <P.SportStrip sport={this.getCurrentSport()} />}
					{this.getCurrentSport() && <TodayWidget sport={this.getCurrentSport()}  showPagination={false} />}
				</Fragment>
	}
}